module.exports = __webpack_public_path__ + "static/media/IND40_ best.ad8a9a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/IND40_ best.jpg
// module id = 218
// module chunks = 0